@if (credits) {
  <div class="tax-credits-button-row">
    @if (!editingCredits) {
      <button mat-button class="edit-button" (click)="editTaxCreditsButton()">Edit</button>
    }
    @if (editingCredits) {
      <button mat-button class="edit-button" (click)="editTaxCreditsButton()">Cancel Editing</button>
    }
    @if (editingCredits) {
      <button mat-button class="edit-button" (click)="saveTaxCreditsButton()">Save</button>
    }
    @if (editingCredits) {
      <button mat-button class="edit-button add" (click)="addTaxCreditsButton()">Add Tax Credit</button>
    }
  </div>
}

@if (credits && !editingCredits) {
  <div class="row align-top gutters">
    @for (credit of credits; track credit) {
      <div class="col-md-4">
        <div class="subsection-header" [ngClass]="!credit.crea_syndicated ? 'yellow' : credit.name.includes('Federal') ? 'teal' :  'purple'">{{credit.name}}</div>
        <deal-tax-credits-table [importedTable]="credit.table"></deal-tax-credits-table>
      </div>
    }
  </div>
}
@if (credits.length === 0 || editingCredits && creditsEdit.length === 0) {
  <div class="row align-top gutters">
    <div class="col-md-12">
      <em>There are no Tax Credits for this deal.</em>
    </div>
  </div>
}

@if (credits && editingCredits) {
  <div class="row align-top gutters">
    @for (credit of creditsEdit; track credit; let i = $index) {
      <div class="col-md-4">
        @if (credit.id) {
          <div class="subsection-header" [ngClass]="!credit.crea_syndicated ? 'yellow' : credit.name.includes('Federal') ? 'teal' :  'purple'">{{credit.name}}</div>
        }
        @if (!credit.id) {
          <div class="subsection-header" [ngClass]="!credit.crea_syndicated ? 'yellow' : (credit.name && credit.name.includes('Federal')) ? 'teal' : 'purple'" >(New) <mat-form-field>
            <mat-select [(ngModel)]="credit.tax_credit_type" (selectionChange)="changeCreditType(credit)" required>
              @for (tct of taxCreditTypes; track tct) {
                <mat-option [value]="tct">{{tct.level + " " + tct.name}}</mat-option>
              }
            </mat-select></mat-form-field>
            @if (credit.name && credit.name === 'Federal LIHTC') {
              <mat-form-field class="designation-dropdown">
                <mat-select [(ngModel)]="credit.tax_credit_designation_id" required>
                  @for (tcd of taxCreditDesignations; track tcd) {
                    <mat-option [value]="tcd.id">{{tcd.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
        }
        @if (!credit.deleting) {
          <div>
            <div class="mat-elevation-z8">
              <div class="row">
                <div class="col-md-5 edit-row edit-field-name">Total Credits</div>
                <div class="col-md-5 edit-row"><mat-form-field class="edit-credit-field"><input matInput type="number" [(ngModel)]="credit.amount"/></mat-form-field></div>
                <div class="col-md-5 edit-row edit-field-name">Price Per Credit</div>
                <div class="col-md-5 edit-row"><mat-form-field class="edit-credit-field"><input matInput type="number" [(ngModel)]="credit.price"/></mat-form-field></div>
                <div class="col-md-5 edit-row edit-field-name">Lower Tier Equity</div>
                <div class="col-md-5 edit-row"><mat-form-field class="edit-credit-field"><input matInput type="number" [(ngModel)]="credit.equity_amount"/></mat-form-field></div>
                <div class="col-md-5 edit-row edit-field-name">Credit Status</div>
                <div class="col-md-5 edit-row">
                  <mat-form-field>
                    <mat-select [(ngModel)]="credit.projectCreditStatus" [placeholder]="credit.projectCreditStatus ? credit.projectCreditStatus.name : ''">
                      @for (pcs of projectCreditStatuses; track pcs) {
                        <mat-option [value]="pcs">{{pcs.name}}</mat-option>
                      }
                      <mat-option [value]="null">N/A</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-5 edit-row edit-field-name">Certificated</div>
                <div class="col-md-5 edit-row">
                  <mat-radio-group [(ngModel)]="credit.certificated">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="col-md-5 edit-row edit-field-name">CREA Syndicated</div>
                <div class="col-md-5 edit-row">
                  <mat-radio-group [(ngModel)]="credit.crea_syndicated">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="col-md-12 edit-row">
                  @if (permsService.userPerms['PROJECTDETAIL']['_']['_edit']) {
                    <button mat-button class="edit-button delete" (click)="credit.deleting = true;">
                      Delete Credit
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (credit.deleting) {
          <div class="deleting-tax-credit-outer">
            <div class="deleting-tax-credit-inner edit-field-name">
              <br><br>
              Are you sure?
            </div>
            <div>
              <br>
                <button mat-button (click)="deleteCredit(i)" class="red-edit-button">Yes</button>
                <button mat-button (click)="credit.deleting = false;"  class="edit-button">No</button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
